export function Divider(){
  return <div className="h-[1px] w-full bg-[#545A6340]" />;
}
